import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';

import EditorState from 'draft-js/lib/EditorState';
import convertFromRaw from 'draft-js/lib/convertFromRawToDraftState';
import convertToRaw from 'draft-js/lib/convertFromDraftStateToRaw';
import convertFromHTML from 'draft-js/lib/convertFromHTMLToContentBlocks';
import ContentState from 'draft-js/lib/ContentState';

import draftToHtml from 'draftjs-to-html';

export const editorStateToRaw = editorState => {
  if (isEmpty(editorState)) {
    return null;
  }
  return convertToRaw(editorState.getCurrentContent());
  //// ? TODO: check this old question from edit_soundcast.js getParsedLongDescription(descState) {...
  //// draft js Editor automatically added "http://" in links if the user enters links without a prefix
  //// the commented code below incorrectly adds an extra prefix for some of the correct links
  // ...
  // const urlPattern = new RegExp(
  //   /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i
  // );
  // // mutate the raw entity and set the right url to incomplete links
  // if ('entityMap' in longDescRaw && isObject(longDescRaw.entityMap)) {
  //   for (let entitykey in longDescRaw.entityMap) {
  //     const entity = longDescRaw.entityMap[entitykey];
  //     if (entity.type === 'LINK') {
  //       if (!urlPattern.test(entity.data.url)) {
  //         longDescRaw.entityMap[entitykey].data.url = `https://${entity.data.url}`;
  //       }
  //     }
  //   }
  // }
};

export const editorStateToRawAndHtml = editorState => {
  if (isEmpty(editorState)) {
    return { raw: null, html: null };
  }
  const raw = editorStateToRaw(editorState);
  const html = draftToHtml(raw);
  return { raw, html };
};

export const htmlToEditorState = (textHtml, isDefault = false) => {
  const contentBlocks = convertFromHTML(textHtml);
  const contentState = ContentState.createFromBlockArray(
    contentBlocks.contentBlocks,
    contentBlocks.entityMap
  );
  const editorState = EditorState.createWithContent(contentState);
  const { raw, html } = editorStateToRawAndHtml(editorState);
  return { editorState, raw, html, isDefault };
};

export const createEditorState = (jsonRawPrev = '', htmlDefault = '') => {
  let editorState = EditorState.createEmpty();

  if (isEmpty(jsonRawPrev) && isEmpty(htmlDefault)) {
    const { raw, html } = editorStateToRawAndHtml(editorState);
    return { editorState, raw, html, isDefault: false };
  }

  let rawPrev = null;
  if (!isEmpty(jsonRawPrev)) {
    try {
      rawPrev = JSON.parse(jsonRawPrev);
    } catch (err) {
      console.err(`createEditorState errored`, err);
    }
  }
  if (!isEmpty(rawPrev)) {
    const contentState = convertFromRaw(rawPrev);
    editorState = EditorState.createWithContent(contentState);
  }
  if (isEmpty(htmlDefault)) {
    const { raw, html } = editorStateToRawAndHtml(editorState);
    return { editorState, raw, html, isDefault: false };
  }

  const defObj = htmlToEditorState(htmlDefault, true);
  if (isEmpty(rawPrev)) {
    return defObj;
  }

  const { raw, html } = editorStateToRawAndHtml(editorState);
  return { editorState, raw, html, isDefault: isEqual(html, defObj.html),
  };
};

export const rawIsEmpty = (rawJsonStr) => {
  if (isEmpty(rawJsonStr)) {
    return true;
  }
  let rawObj = null;
  if (isString(rawJsonStr)) {
    try {
      rawObj = JSON.parse(rawJsonStr);
    } catch (err) {
      return false; // incorrect format
    }
  } else if (isObject(rawJsonStr)) {
    rawObj = rawJsonStr;
  }
  if (isEmpty(rawObj)) {
    return true;
  }
  const blocks = rawObj.blocks || [];
  if (blocks.length > 0) {
    // correct format
    for (const block of blocks) {
      const { text = null } = block || {};
      if (!isEmpty(text)) {
        return false;
      }
    }
    return true;
  }
  return false; // incorrect format
};

export const htmlIsEmpty = (html) => {
  if (isEmpty(html) || isEqual(html, '<p></p>\n') || isEqual(html, '<p></p>') || isEqual(html, '<div></div>')) {
    return true;
  }
  if (isEqual(html, '<div></div>\n') || isEqual(html, '<div></div>')) {
    return true;
  }
  return false;
};
